import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiPaper from '@material-ui/core/Paper';
import MuiBox from '@material-ui/core/Box';
import MuiTypography from '@material-ui/core/Typography';
import MuiButton from '@material-ui/core/Button';
import MuiDivider from '@material-ui/core/Divider';
import MuiTooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import GetAppIcon from '@material-ui/icons/GetApp';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const styles = theme => ({
  root: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  selectionInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  divider: {
    height: 24,
    margin: theme.spacing(0, 2),
  },
});

/**
 * Component for displaying actions for selected items in tables
 * Shows the number of selected items and provides action buttons
 */
const SelectionActions = props => {
  const {
    classes,
    selectedCount,
    onClearSelection,
    onExportSelected,
    onApproveSelected,
    disableExport,
    disableApprove,
  } = props;

  if (selectedCount === 0) return null;

  return (
    <MuiPaper className={classes.root} elevation={0}>
      <MuiBox className={classes.selectionInfo}>
        <MuiTypography variant="body2">
          {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
        </MuiTypography>
        <MuiTooltip title="Clear selection">
          <MuiButton
            size="small"
            startIcon={<ClearIcon />}
            onClick={onClearSelection}>
            Clear
          </MuiButton>
        </MuiTooltip>
      </MuiBox>

      <MuiBox className={classes.actions}>
        <MuiTooltip
          title={
            disableExport ? 'Export not available' : 'Export selected items'
          }>
          <span>
            <MuiButton
              size="small"
              color="primary"
              startIcon={<GetAppIcon />}
              onClick={onExportSelected}
              disabled={disableExport}>
              Export
            </MuiButton>
          </span>
        </MuiTooltip>

        <MuiDivider orientation="vertical" className={classes.divider} />

        <MuiTooltip
          title={
            disableApprove ? 'Approve not available' : 'Approve selected items'
          }>
          <span>
            <MuiButton
              size="small"
              color="primary"
              startIcon={<CheckCircleIcon />}
              onClick={onApproveSelected}
              disabled={disableApprove}>
              Approve
            </MuiButton>
          </span>
        </MuiTooltip>
      </MuiBox>
    </MuiPaper>
  );
};

SelectionActions.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedCount: PropTypes.number.isRequired,
  onClearSelection: PropTypes.func.isRequired,
  onExportSelected: PropTypes.func,
  onApproveSelected: PropTypes.func,
  disableExport: PropTypes.bool,
  disableApprove: PropTypes.bool,
};

SelectionActions.defaultProps = {
  onExportSelected: () => {},
  onApproveSelected: () => {},
  disableExport: false,
  disableApprove: false,
};

export default withStyles(styles)(SelectionActions);
